import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../lib/auth";


export default function Nav() {
  const [me, setMe] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchMe() {
      try {
        const user = await auth.me();
        setMe(user);
      } catch {
        setMe(null);
      }
    }

    fetchMe(); // initial load

    // listen for login/logout events
    function handleAuthChange() {
      fetchMe();
    }
    window.addEventListener("storage", handleAuthChange);

    return () => {
      window.removeEventListener("storage", handleAuthChange);
    };
  }, []);

  async function handleLogout() {
    try {
      await auth.logout();
    } catch (e) {
      console.error("Logout failed", e);
    }
    setMe(null);
    navigate("/");
  }

  return (
    <nav>
      <img src="/logo.png" alt="Logo" style={{ height: 32 }} />
      <Link to="/">Calculator</Link>
      {me?.role === "admin" && (
        <>
          <Link to="/admin">Leads</Link>
          <Link to="/admin/pricing">Settings</Link>
        </>
      )}
      <div style={{ flex: 1 }} />
      {me ? (
        <button className="btn-accent" onClick={handleLogout}>Logout</button>
      ) : (
        <Link to="/login">Login</Link>
      )}
    </nav>
  );
}